import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import { get_cdn_url, use_store } from "../store";
import Button from "./button";
import {
  faCheck,
  // faEyes,
  // faSearch,
  // faShield,
  // faUserHatTieMagnifyingGlass,
} from "@fortawesome/pro-regular-svg-icons";
import { faCircle as faCircleLight } from "@fortawesome/pro-light-svg-icons";
import { faCircleCheck, faStars } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useLocation } from "wouter";
import { FacesLite } from "./faces";

// Individual subscription option button component
const SubscriptionOptionButton = ({
  label,
  extra_label,
  is_selected,
  on_click,
}: {
  label: string;
  extra_label?: string;
  is_selected: boolean;
  on_click: () => void;
}) => {
  const [screen_width, set_screen_width] = useState(window.innerWidth);

  useEffect(() => {
    const handle_resize = () => {
      set_screen_width(window.innerWidth);
    };

    window.addEventListener("resize", handle_resize);
    return () => window.removeEventListener("resize", handle_resize);
  }, []);

  return (
    <button
      onClick={on_click}
      className={`flex-1 py-[8px] rounded-[4px] transition-all duration-200 cursor-pointer px-[12px] ${
        is_selected
          ? "border-[2px] border-brand-2 bg-brand-2/20"
          : "border-[1px] my-[1px] border-lines bg-surface"
      }`}
    >
      <div className={`flex items-center justify-start gap-[8px]  w-full`}>
        <FontAwesomeIcon
          icon={is_selected ? faCircleCheck : faCircleLight}
          className={`text-[16px] mb-[1px] ${is_selected ? "text-brand-2" : "text-lines"}`}
        />
        <p className={`eyebrows text-primary mt-[1px]`}>
          <span>{label}</span>
          {screen_width >= 400 && extra_label && (
            <span className="text-primary">{extra_label}</span>
          )}
          {screen_width < 400 && extra_label && (
            <p className="text-primary"> {extra_label}</p>
          )}
        </p>
      </div>
    </button>
  );
};

// Subscription type selector component
// @ts-ignore
const SubscriptionTypeSelector = () => {
  const { sub_type, set_sub_type, unique_data } = use_store();

  return (
    <div className="flex flex-row gap-[8px] w-full">
      <SubscriptionOptionButton
        label={unique_data.price_string.replace("/", " / ")}
        is_selected={sub_type === "weekly"}
        on_click={() => set_sub_type("weekly")}
      />
      <SubscriptionOptionButton
        label={unique_data.price_string_2.replace("/", " / ")}
        is_selected={sub_type === "monthly"}
        on_click={() => set_sub_type("monthly")}
      />
    </div>
  );
};

export default function WhySubscribeCard() {
  // @ts-ignore
  const { t, unique_data, sub_type, call_add_to_cart } = use_store();
  const [show_sticky_bar, set_show_sticky_bar] = useState(false);
  const [_, set_location] = useLocation();

  useEffect(() => {
    const handle_scroll = () => {
      const scrolled = window.scrollY > 280;
      const is_mobile = window.innerWidth < 600;
      set_show_sticky_bar(scrolled && is_mobile);
    };

    const handle_resize = () => {
      const scrolled = window.scrollY > 280;
      const is_mobile = window.innerWidth < 600;
      set_show_sticky_bar(scrolled && is_mobile);
    };

    window.addEventListener("scroll", handle_scroll);
    window.addEventListener("resize", handle_resize);
    handle_scroll();

    return () => {
      window.removeEventListener("scroll", handle_scroll);
      window.removeEventListener("resize", handle_resize);
    };
  }, []);
  // @ts-ignore
  const face_images = [
    "/faces/face5.webp",
    "/faces/face6.webp",
    "/faces/face7.webp",
    "/faces/face8.webp",
  ];

  if (!unique_data) {
    return null;
  }

  return (
    <div className="">
      <div className="text-center mb-[16px]">
        <div className="flex items-baseline items-center gap-[10px] justify-start mb-[8px] w-full flex-row">
          <div className="bg-lines h-[1px] flex-1 flex-grow"></div>
          <p className="px-[16px] eyebrows text-secondary">{unique_data.price_string}</p>
          <div className="bg-lines h-[1px] flex-1 flex-grow"></div>
        </div>
      </div>
      {/*<div className="flex flex-row w-full items-center gap-[16px] mb-[12px]">
        <div className="flex flex-1 flex-grow w-full h-[1px] bg-lines"></div>
        <p className="eyebrows text-secondary uppercase min-w-fit">
            {unique_data.price_string.replace("/", " per ")}
        </p>
        <div className="flex flex-1 flex-grow w-full h-[1px] bg-lines"></div>
      </div>*/}

      <h2 className="mtitle w-full text-left mb-[16px]">
        {t("Stop guessing, learn the truth, and reduce your anxiety levels with Lulu Loyal’s tools.")}
      </h2>

      {/*<SubscriptionTypeSelector />*/}

      <div className="flex flex-col justify-center w-full mt-[24px] items-start mb-[24px] gap-[16px] w-full ">
        {[
          [faCheck, t("Unlimited Searches.")],
          [faCheck, t("Completely Anonymous.")],
          [faCheck, t("No Commitment. Cancel Anytime.")],
          [faCheck, t("Easy to Cancel.")],
          [faCheck, t("Secured by Stripe Payments.")],
        ].map((x, i) => {
          return (
            <div
              className="flex flex-row w-full justify-start items-center"
              key={`buy-box-${i}`}
            >
              <FontAwesomeIcon
                icon={x[0] as IconProp}
                className="text-[16px] text-brand-2 mr-[8px]"
              ></FontAwesomeIcon>
              <p className="text-primary vsmallt">{x[1] as string}</p>
            </div>
          );
        })}
      </div>

      <div className="flex flex-row w-full flex-1 flex-grow gap-[8px]">
        {/*<p className="p-[16px] mt-[6px] vsmallt min-w-[124px]">
          {sub_type === "monthly"
            ? unique_data.price_string_2
            : unique_data.price_string}
        </p>*/}
        <Button onClick={() => {
          call_add_to_cart()
          set_location("/account")
        }}>
          <p className="py-[6px] items-center gap-[4px] flex flex-row flex-center">
            <FontAwesomeIcon className="mb-[4px]" icon={faStars}></FontAwesomeIcon>
            <span>{t("Subscribe to Reveal All")}</span></p>
        </Button>
      </div>

      <div
        className={`fixed bottom-[-20px] right-0 p-[16px] pb-[68px] bg-surface-secondary border-t-[1px] border-lines w-screen transition-all duration-1000 ease-out ${
          show_sticky_bar
            ? "bottom-0 translate-y-0"
            : "bottom-0 translate-y-full"
        }`}
        id="sticky-bar"
      >
        <div className="flex flex-row w-full flex-1 flex-grow gap-[8px]">
          {/* <p className="p-[16px] vsmallt w-[150px]">
            {sub_type === "monthly"
              ? unique_data.price_string_2
              : unique_data.price_string}
          </p> */}
          <Button onClick={() => {
            call_add_to_cart()
            set_location("/account")
          }}>
             <p className="py-[6px] items-center gap-[4px] flex flex-row flex-center">
            <FontAwesomeIcon className="mb-[4px]" icon={faStars}></FontAwesomeIcon>
            <span>{t("Subscribe to Reveal All")}</span></p>
          </Button>
        </div>
      </div>
      <div className="mt-[12px]"></div>
      <FacesLite></FacesLite>
      <div className="flex w-full flex-row flex-1 flex-grow gap-[4px]">
        <div className="flex items-center gap-[24px] rounded-[4px] border-lines border-[1px] p-[8px] eyebrows flex flex-row justify-between items-center flex-1 flex-grow">
          <p>{t("FIND RED FLAGS")}</p>
          <p></p>
        </div>
        <div className="flex items-center gap-[24px] rounded-[4px] border-lines border-[1px] p-[8px] eyebrows flex flex-row justify-between items-center flex-1 flex-grow">
          <p>{t("BEST RESULTS")}</p>
          <p>💯</p>
        </div>
      </div>
    </div>
  );
}
